import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "tint" | "white" | "onbrand" | "dsoft";

interface BtnOwnProps {
  variant?: Variant;
  size?: "sm";
  /** Adds the brand-green floating shadow (primary CTA). */
  float?: boolean;
}

type BtnAnchorProps = BtnOwnProps & { as: "a" } & AnchorHTMLAttributes<HTMLAnchorElement>;
type BtnButtonProps = BtnOwnProps & { as?: "button" } & ButtonHTMLAttributes<HTMLButtonElement>;

// UI System v2 button (classes live in styles/base.css). `as="a"` renders a link.
export function Btn(props: BtnAnchorProps | BtnButtonProps) {
  const { variant = "primary", size, float, className, ...rest } = props;
  const cls = ["btn", `btn-${variant}`, size === "sm" && "btn-sm", float && "btn-float", className]
    .filter(Boolean)
    .join(" ");
  if (rest.as === "a") {
    const { as: _as, ...a } = rest;
    void _as;
    return <a className={cls} {...a} />;
  }
  const { as: _as, type = "button", ...b } = rest as BtnButtonProps;
  void _as;
  return <button className={cls} type={type} {...b} />;
}
